import React, { useState, useRef, useEffect } from "react";
import { useAuth } from "@/AuthContext";
import { Buildings, CaretDown, Check } from "@phosphor-icons/react";

export default function CompanySwitcher() {
  const { companies, activeCompanyId, setActiveCompany, activeStructureId } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  // Si hay estructura activa, la estructura organizacional controla el contexto;
  // ocultamos este selector para evitar contradicciones (ver req. §5).
  if (activeStructureId) return null;
  if (!companies || companies.length === 0) return null;
  const active = companies.find(c => c.id === activeCompanyId) || companies[0];
  const single = companies.length === 1;

  return (
    <div className="relative" ref={ref} data-testid="company-switcher">
      <button
        onClick={() => !single && setOpen(o => !o)}
        disabled={single}
        className={`flex items-center gap-2 px-3 py-1.5 rounded-md border border-neutral-200 text-sm font-medium text-neutral-700 hover:bg-neutral-100 transition-colors ${single ? 'cursor-default opacity-90' : ''}`}
        data-testid="company-switcher-btn"
        title={single ? "Empresa activa" : "Cambiar empresa"}
      >
        <Buildings size={16} weight="duotone" className="text-blue-600" />
        <span className="max-w-[160px] truncate">{active?.name || "Empresa"}</span>
        {!single && <CaretDown size={12} weight="bold" />}
      </button>
      {open && !single && (
        <div className="absolute right-0 mt-2 w-64 bg-white border border-neutral-200 rounded-md shadow-lg overflow-hidden z-50" data-testid="company-switcher-menu">
          <div className="px-3 py-2 text-xs uppercase tracking-widest text-neutral-500 border-b border-neutral-100">Tus empresas</div>
          <div className="max-h-80 overflow-y-auto">
            {companies.map(c => {
              const isActive = c.id === activeCompanyId;
              return (
                <button
                  key={c.id}
                  onClick={() => { setOpen(false); setActiveCompany(c.id); }}
                  className={`w-full flex items-center justify-between gap-2 px-3 py-2.5 text-sm hover:bg-neutral-50 transition-colors ${isActive ? 'bg-blue-50 text-blue-700 font-semibold' : 'text-neutral-700'}`}
                  data-testid={`company-switcher-option-${c.id}`}
                >
                  <span className="truncate">{c.name}</span>
                  {isActive && <Check size={16} weight="bold" />}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
